import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Vahvista sähköpostiosoite',
  [OnboardingStep.BusinessInfo]: 'Lisää liikkeesi tiedot',
  [OnboardingStep.PersonalInfo]: 'Lisää henkilötietosi',
  [OnboardingStep.ShippingInfo]: 'Lisää toimitustietosi',
  [OnboardingStep.BankInfo]: 'Lisää pankkitiedot maksuja varten',
  [OnboardingStep.TaxInfo]: 'Onko yrityksesi arvonlisäverovelvollinen?',
  [OnboardingStep.BusinessDocs]: 'Yritystodistus',
  [OnboardingStep.PersonalDocs]: 'Henkilöllisyystodistus',
  [OnboardingStep.InfoSubmission]: 'Saa maksuja',
  confirm_info_gateway: 'Saa maksuja – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Maksutiedot',
  [OnboardingStep.Subscription]: 'Tilaus',
  [OnboardingStep.MobileApp]: 'Mobiilisovellus',
  [OnboardingStep.DeliveryStructure]: 'Toimitusrakenne',
  [OnboardingStep.Contract]: 'Sopimus',
  [OnboardingStep.ContractPayment]: 'Sopimusmaksu',
  [OnboardingStep.PromoCode]: 'Alennuskoodi',
};
